/* tslint:disable */
/* eslint-disable */
/**
 * Document Simulation API
 * API for managing document simulations and contractualization strategies
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types de fichiers supportés par le système
 * @export
 */
export const SupportTypeEnum = {
    All: 0,
    Individual: 1,
    Group: 2
} as const;
export type SupportTypeEnum = typeof SupportTypeEnum[keyof typeof SupportTypeEnum];


export function instanceOfSupportTypeEnum(value: any): boolean {
    for (const key in SupportTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(SupportTypeEnum, key)) {
            if (SupportTypeEnum[key as keyof typeof SupportTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SupportTypeEnumFromJSON(json: any): SupportTypeEnum {
    return SupportTypeEnumFromJSONTyped(json, false);
}

export function SupportTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportTypeEnum {
    return json as SupportTypeEnum;
}

export function SupportTypeEnumToJSON(value?: SupportTypeEnum | null): any {
    return value as any;
}

export function SupportTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): SupportTypeEnum {
    return value as SupportTypeEnum;
}

